//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    icon: {
      type: String,
      default: undefined,
    },
    text: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: undefined,
    },
  },
}
